// extracted by mini-css-extract-plugin
export var chevronIcon = "_e2-2";
export var teamName = "_e2-1";
export var teamSwitcherButton = "_e2-0";